import React from 'react';

interface Props {
  unreadMessageCount: number;
}

export const DashboardInboxTitle = ({ unreadMessageCount }: Props) => {
  if (unreadMessageCount === 0) {
    return <h1 className='text-bedrock-serif-h1 text-bedrock-black'>You’re up to date</h1>;
  }

  return (
    <h1 className='text-bedrock-serif-h1 text-bedrock-black'>
      You have{' '}
      <span className='text-bedrock-brand-secondary'>
        {unreadMessageCount} unread conversation{unreadMessageCount === 1 ? '' : 's'}
      </span>
    </h1>
  );
};
